import { render } from "./faqPart.vue?vue&type=template&id=46e8b6d5"
import script from "./faqPart.vue?vue&type=script&lang=js"
export * from "./faqPart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__